import * as React from 'react';
import {Atom, withSystem, Plugins} from '@packages/systems/wfdl';
import {typeName, iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TTypeConstructor, TRecord} from '@packages/systems/wfdl-ast';
import {excludeSearchByDefaultType} from '@packages/systems/search';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {aspectRatio} from './videoEmbedValue';

// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
const createMarkup = (value) => {
  return value ? {__html: value} : null;
};

const Video = Atom.createRender(
  ({attributes, classes, data, generateAttributes, innerHTML}) => {
    const value =
      // @ts-expect-error - innerHTML.metadata is missing in Array|List|String
      innerHTML?.metadata?.html ??
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      data?.video?.value ??
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      data?.video?.embed?.meta?.html;

    const paddingTop: string =
      // @ts-expect-error - TS2339 - Property 'metadata' does not exist on type 'List<JSONNode> | JSONNode[] | VideoBindingProps'.
      innerHTML && typeof innerHTML !== 'string' && innerHTML.metadata
        ? // @ts-expect-error - TS2339 - Property 'metadata' does not exist on type 'List<JSONNode> | JSONNode[] | VideoBindingProps'.
          `${aspectRatio(innerHTML.metadata) * 100}%`
        : // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
          data?.video?.style?.['padding-top'];

    attributes = attributes.setIn(['style', 'padding-top'], paddingTop);
    const videoClasses = classes.push('w-video').push('w-embed');

    return (
      <div
        {...generateAttributes(attributes, videoClasses)}
        // @ts-expect-error - TS2322 - Type '{ __html: any; } | null' is not assignable to type '{ __html: string | TrustedHTML; } | undefined'.
        dangerouslySetInnerHTML={createMarkup(value)}
      />
    );
  }
);

// TODO: We should remove the :empty CSS selectors from site-designer.less that affect embeds and just let it be decorated like other atoms
const config = createDevlinkAtom({
  displayName: 'Video',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Embed'), iconName('Video')),
  },
  showEmpty: false,
  lockedStyles: {
    paddingTop: {
      when: true,
      message:
        'The top padding is automatically calculated in order to make this video responsive.',
    },
  },
  render: Video,
  fields: {
    search: withSystem(
      {private: true},
      TRecord({
        exclude: excludeSearchByDefaultType,
      })
    ),
    video: withSystem(
      {
        isBindable: true,
        label: 'Video',
      },
      TTypeConstructor(qualify(Plugins.name('Embed'), typeName('Video')))
    ),
  },
});

export default config;
